import _sfc_main from './MarketSelector.vue2.js';
import normalizeComponent from '../../_virtual/_plugin-vue2_normalizer.js';

var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "fds-widget fds-ui-input fds-ui-input--select fds-market-selector", class: { "fds-ui-loading": _setup.isLoadingStoreData, "fds-ui-input--disabled": _setup.isSelectDisabled } }, [_vm._t("root", function() {
    return [_vm._t("input", function() {
      return [_vm._t("input:label", function() {
        return [_c("label", { staticClass: "fds-ui-input__label", attrs: { "for": _setup.marketSelectorId } }, [_vm._v(_vm._s(_setup.translate("marketSelector.selectionLabel")))])];
      }, null, { localizationSupport: _setup.localizationSupport, storeModule: _setup.storeModule, marketSelectorId: _setup.marketSelectorId, label: "marketSelector.selectionLabel" }), _vm._t("input:field", function() {
        return [_c("div", { staticClass: "fds-ui-input__field" }, [_c("select", { directives: [{ name: "model", rawName: "v-model", value: _setup.selected, expression: "selected" }], attrs: { "id": _setup.marketSelectorId, "aria-label": _setup.translate("marketSelector.selectionLabel"), "disabled": _setup.isSelectDisabled }, on: { "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected;
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val;
          });
          _setup.selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
        }, _setup.onMarketChange] } }, _vm._l(_setup.storeData || [], function(market) {
          return _c("option", { key: JSON.stringify(market.id), domProps: { "value": market } }, [_vm._v(" " + _vm._s(_setup.textFormat(market.name)) + " "), _vm.showCurrency ? [_vm._v("(" + _vm._s(_setup.textFormat(market.currency)) + ")")] : _vm._e()], 2);
        }), 0)])];
      }, null, { localizationSupport: _setup.localizationSupport, storeModule: _setup.storeModule, marketSelectorId: _setup.marketSelectorId, selected: _setup.selected, onMarketChange: _setup.onMarketChange, isSelectDisabled: _setup.isSelectDisabled })];
    }, null, { localizationSupport: _setup.localizationSupport, storeModule: _setup.storeModule, marketSelectorId: _setup.marketSelectorId, selected: _setup.selected, onMarketChange: _setup.onMarketChange, isSelectDisabled: _setup.isSelectDisabled })];
  }, null, { localizationSupport: _setup.localizationSupport, storeModule: _setup.storeModule, marketSelectorId: _setup.marketSelectorId, selected: _setup.selected, onMarketChange: _setup.onMarketChange, isSelectDisabled: _setup.isSelectDisabled })], 2);
};
var _sfc_staticRenderFns = [];
_sfc_render._withStripped = true;
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null,
  null,
  null
);
__component__.options.__file = "/home/ubuntu/actions-runner/_work/library/library/packages/library/src/components/market-selector/MarketSelector.vue";
var MarketSelector = __component__.exports;

export { MarketSelector as default };
